import React, {Component} from 'react'
import Style from './AdminManagement.module.css'
import { getUsersList, removeAdmin, unSetStatusCode, resetAdminPassword } from '../store/entities/customers'
import { connect } from 'react-redux'
import { formatDetectionDatetime } from '../utilities/datetime'
import { withRouter } from 'react-router-dom';
import ConfirmPopup from "./common/popover/confirmPopup";
import LoaderWrapper from './common/LoaderWrapper/LoaderWrapper'
import updateSvg from '../assets/update.svg'
import RefreshIcon from '../assets/refresh.svg'


import DashIcon from '../assets/minus.png' 
import PlusIcon from '../assets/pluss.png'
// import { height } from '@fortawesome/free-brands-svg-icons/fa42Group'

const adminConfig = {
    PixmAdmin: {
        title: 'Pixm Admin Management',
        adminTitle: 'Pixm Admin',
        inviteText: 'Add and invite Pixm admin',
        isResetPasswordEnabled: true,
        isUpdateAdminEnabled: true,
        isRemoveAdminEnabled: true,
        addAdminPath: '/advanced-settings/add-pixm-admin',
        updateAdminPath: '/advanced-settings/update-pixm-admin'
    },
    TenantAdmin: {
        title: 'MSP Admin Management',
        adminTitle: 'MSP Admin',
        inviteText: 'Add and invite admin',
        isResetPasswordEnabled: false,
        isUpdateAdminEnabled: false,
        isRemoveAdminEnabled: true,
        addAdminPath: '/tenant-admin/add-admin',
        updateAdminPath: '/tenant-admin' // not currently used
    },
    CustomerAdmin: {
        title: 'Customer Admin Management',
        adminTitle: 'Customer Admin',
        inviteText: 'Add and invite admin',
        isResetPasswordEnabled: false,
        isUpdateAdminEnabled: false,
        isRemoveAdminEnabled: true,
        addAdminPath: '/customers/:id/settings/add-admin',
        updateAdminPath: '/customers/:id/settings' // not currently used
    },
    default: {
        title: 'Admin Management',
        adminTitle: 'Admin',
        inviteText: 'Add and invite admin',
        isResetPasswordEnabled: false,
        isUpdateAdminEnabled: false,
        isRemoveAdminEnabled: true,
        addAdminPath: '/customers/:id/settings/add-admin',
        updateAdminPath: '/customers/:id/settings' // not currently used
    }
}
class AdminManagement extends Component {

    constructor(props) {
        super(props);
        this.state = {
          showRemoveConfirmationPopup:false,
          showResetPwdConfirmationPopup:false,
          errors:[],
          userIdToRemove: null,
          emailToResetPwd: null
        };
      }

    componentDidMount() {
        if(this.props.tokenRoles === 'PixmAdmin' && this.props.adminType === 'PixmAdmin') {
            this.props.getUsersList(null, null, 'PixmAdmin')
        } else if(this.props.tokenRoles === 'TenantAdmin' && this.props.adminType === 'TenantAdmin') {
            this.props.getUsersList(null, null, 'TenantAdmin')
        } else if(this.props.selectedCustomer && this.props.tokenRoles === 'TenantAdmin') {
            this.props.getUsersList(null, this.props.selectedCustomer.id, 'CustomerAdmin')
        } else if(this.props.tokenRoles === 'CustomerAdmin') {
            this.props.getUsersList(null, null, null)
        } else if(this.props.selectedCustomer && this.props.tokenRoles === 'PixmAdmin') {
            let tenantDetailsForCustomer = this.props.tenantList.filter((item) => item.tenantId === this.props.selectedCustomer.tenantId)
            this.props.getUsersList(tenantDetailsForCustomer[0] && tenantDetailsForCustomer[0].gcipTenantId, this.props.selectedCustomer.id, 'CustomerAdmin')
        }   
    }

    componentDidUpdate(prevProps) {
            if(prevProps.userFlag !== this.props.userFlag) {
                if(this.props.tokenRoles === 'PixmAdmin' && this.props.adminType === 'PixmAdmin') {
                this.props.getUsersList(null, null, 'PixmAdmin')
            } else if(this.props.tokenRoles === 'TenantAdmin' && this.props.adminType === 'TenantAdmin') {
                this.props.getUsersList(null, null, 'TenantAdmin')
            } else if(this.props.userFlag && this.props.tokenRoles === 'TenantAdmin') {
                this.props.getUsersList(null, this.props.selectedCustomer.id, 'CustomerAdmin')
            } else if(this.props.tokenRoles === 'CustomerAdmin') {
                this.props.getUsersList(null, null, null)
            } else if(this.props.selectedCustomer && this.props.tokenRoles === 'PixmAdmin') {
                let tenantDetailsForCustomer = this.props.tenantList.filter((item) => item.tenantId === this.props.selectedCustomer.tenantId)
                this.props.getUsersList(tenantDetailsForCustomer[0].gcipTenantId, this.props.selectedCustomer.id, 'CustomerAdmin')
            }
        }
    }

    handleRemoveAdmin = (userId) => {
        this.setState({ showRemoveConfirmationPopup: true, userIdToRemove: userId })
    }

    handleResetAdminPwd = (email) => {
        this.setState({ showResetPwdConfirmationPopup: true, emailToResetPwd: email })
    }

    handleInviteAdmin = () => {
        let { adminType } = this.props
        if(adminType === 'PixmAdmin' || adminType === 'TenantAdmin') {
            this.props.history.push(adminConfig[adminType].addAdminPath)
        } else {
        this.props.history.push(`/customers/${this.props.selectedCustomer.id}/settings/add-admin`);
        } 
    }

    isRemoveAdminEnabled = (adminType) => {
        return (typeof adminConfig[adminType] !== 'undefined' ? adminConfig[adminType].isRemoveAdminEnabled : adminConfig.default.isRemoveAdminEnabled)
    }

    isResetPasswordEnabled = (adminType) => {
        return (typeof adminConfig[adminType] !== 'undefined' ? adminConfig[adminType].isResetPasswordEnabled : adminConfig.default.isResetPasswordEnabled)
    }

    isUpdateAdminEnabled = (adminType) => { 
        return (typeof adminConfig[adminType] !== 'undefined' ? adminConfig[adminType].isUpdateAdminEnabled : adminConfig.default.isUpdateAdminEnabled)
    }

    handleConfirmRemoveAdmin = () => {
        this.props.removeAdmin(this.state.userIdToRemove)
        this.setState({ showRemoveConfirmationPopup: false, userIdToRemove: null })
    }

    handleConfirmResetAdminPwd = () => {
        this.props.resetAdminPassword(this.state.emailToResetPwd, this.props.tokenRoles)
        this.clearStateValues();
    }

    handleUpdateAdmin = (adminDetails) => {
        // redirecting only to Pixm admin update page as of now as update for TA and CA is not implemented
        this.props.history.push({pathname: `/advanced-settings/update-pixm-admin`, state: { adminData: adminDetails }})
    }

    clearStateValues = () => {
        this.setState({ 
            showRemoveConfirmationPopup: false, 
            userIdToRemove: null,
            showResetPwdConfirmationPopup: false,
            emailToResetPwd: null 
        })
        this.props.unSetStatusCode();
    }

    renderInviteAdminButton = (inviteTitle) => {
        let { adminType } = this.props
        return (
        <div style={{width: '20%'}} className={'ml-4'}>
            <div className={`${Style.fontBold}`}>
            {
                inviteTitle === "inviteIcon" ? (
                    <img style={{height:'20px'}} src={PlusIcon} alt="plus-icon"/>
                ) : 
                inviteTitle ==="textInfo" ? (
                    <div className={`${Style.fontBold}`}>
                    Invite {adminConfig[adminType]?.adminTitle || adminConfig.default.adminTitle}
                    </div> 
                ) : 
                null
            }
            </div>
            <div className={'d-flex mt-3'}>
                <button disabled={ this.props.tokenRoles === 'PixmAdmin' && adminType !== "PixmAdmin" } onClick={this.handleInviteAdmin} className={`${Style.submitButton} focus-none px-4`}>
                    {adminConfig[adminType]?.inviteText || adminConfig.default.inviteText}
                </button>
            </div>
        </div>
        )
    }


    render() {
        let { users, adminType } = this.props
        return (
            <div>
                <div className={'mt-4 w-100'}>
                    <div className={`${Style.titleStyle}`}>
                        {adminConfig[adminType]?.title || adminConfig.default.title}
                    </div>
                    <div className={`${Style.shortInfoStyle} w-100 d-flex align-items-center mt-3 px-5`}>
                        <div className={`${Style.borderStyle} px-4 h-70`} style={{width: 'inherit'}}>
                            <div className={`${Style.fontBold}`}>
                                Current {adminConfig[adminType]?.adminTitle || adminConfig.default.adminTitle} Users
                            </div>
                            <div className={`${Style.currentAdminCount}`}>
                                {
                                    this.props.loading ?
                                        <LoaderWrapper loading={this.props.loading} isFlex={true} styles={{top: '15px', width: '100px'}} waitForData={false}></LoaderWrapper>
                                    :
                                        users.length
                                }
                            </div>
                        </div>
                        {this.renderInviteAdminButton("textInfo")}
                    </div>
                </div>
                <div className={'mt-5'}>
                    <div className={Style.adminsStyle}>
                        {`${adminConfig[adminType]?.adminTitle || adminConfig.default.adminTitle}s`}
                    </div>
                    <div className={'mt-3'}>
                        <div className={`d-flex px-5 mx-2`}>
                            <div className={`${Style.fontBold}`} style={{width:'18%'}}><b>Name</b></div>
                            <div className={`${Style.fontBold}`} style={{width:'60%'}}><b>Email</b></div>
                            <div className={`${Style.fontBold}`} style={{width:'22%'}}><b>Actions</b></div>
                            {this.isResetPasswordEnabled(adminType) && <div className={`${Style.fontBold}`} style={{width:'22%'}}><b></b></div>}
                            {this.isUpdateAdminEnabled(adminType) && <div className={`${Style.fontBold}`} style={{width:'22%'}}><b></b></div>}
                        </div>
                        <div className={`${Style.tableContainerStyle} p-4 mt-3`}>
                            <div className={`${Style.tableStyle} ${Style.ScrollStyle}`}>
                                {
                                    this.props.loading ?
                                        <LoaderWrapper loading={this.props.loading} isFlex={true} styles={{top: '50%'}} waitForData={false}></LoaderWrapper>
                                    :
                                    users.map((item, index) => {
                                        return <div key={item.uid} className={`${ index%2 === 0 ? Style.rowBg : Style.customRowBg} px-4 py-2`}>
                                            <div className={`d-flex p-2`}>
                                                <div className={`${Style.fontBold}`} style={{width:'18%'}}>
                                                    {item.displayName}
                                                </div>
                                                <div style={{width:'60%'}}>
                                                    <div>
                                                        {item.email}
                                                    </div>
                                                    <div>
                                                        Created <i> {formatDetectionDatetime(item.metadata.creationTime)}</i>
                                                    </div>
                                                </div>
                                                { this.isUpdateAdminEnabled(adminType) && <div onClick={() => this.handleUpdateAdmin(item)} className={`${Style.cursorStyle} ${Style.updateAdmin} d-flex`} style={{width:'22%'}}>
                                                        <img
                                                            src={updateSvg}
                                                            style={{ height: '1.5vw' }}
                                                            alt="update-icon"
                                                        />
                                                        Update Info
                                                    </div>  
                                                }
                                                { this.isResetPasswordEnabled(adminType) && <div onClick={() => this.handleResetAdminPwd(item.email)} className={`${Style.cursorStyle} d-flex`} style={{width:'22%'}}>
                                                    <div>
                                                        <img style={{height:'25px'}} src={RefreshIcon} alt="remove-icon"/>
                                                    </div>
                                                    <div className={`${Style.resetPasswordAdmin} ml-1`}>
                                                        Reset Password
                                                    </div>
                                                </div>}
                                                { this.isRemoveAdminEnabled(adminType) &&
                                                <div onClick={() => this.handleRemoveAdmin(item.uid)} className={`${Style.cursorStyle} d-flex`} style={{width:'22%'}}>
                                                    <div>
                                                        <img style={{height:'15px'}} src={DashIcon} alt="remove-icon"/>
                                                    </div>
                                                    <div className={`${Style.removeAdmin} ml-1`}>
                                                        Remove Admin
                                                    </div>
                                                </div>
                                                }   
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                            
                            {this.renderInviteAdminButton()}
                        </div>
                    </div>
                </div>
                {this.state.showResetPwdConfirmationPopup && (
                    <ConfirmPopup
                    details={{
                    icon: '',
                    type: 'info',
                    title: 'Are You Sure?',
                    description: "Do you want to Reset Password for this admin?",
                    buttons: 'Y,C',
                    }}
                    onCancelClick={this.clearStateValues} 
                    onYesClick= {this.handleConfirmResetAdminPwd}
                    />
              )}            
              {this.state.showRemoveConfirmationPopup && (
                    <ConfirmPopup
                    details={{
                    icon: '',
                    type: 'info',
                    title: 'Are You Sure?',
                    description: "Do you want to remove this admin?",
                    buttons: 'Y,C',
                    }}
                    onCancelClick={this.clearStateValues} 
                    onYesClick={this.handleConfirmRemoveAdmin}
                    />
              )}
              {this.props.statusCode && (
                <ConfirmPopup
                details={{
                  icon: '',
                  type: this.props.statusCode === 200 ? 'success':'error',
                  title: this.props.statusCode === 200 ? 'Operation Successful':'Operation Failed',
                  description: this.props.userMsg,
                  buttons: 'O',
                  }}
                  onCloseClick={this.clearStateValues} />
              )}
              
              </div>
        )
    }
}

const mapStateToProps = (state) => ({
    users: state.entities.customers.userList,
    selectedCustomer: state.entities.customers.selected,
    userMsg: state.entities.customers.userMsg,
    statusCode: state.entities.customers.statusCode,
    userFlag: state.entities.customers.userListFlag,
    tokenRoles: state.entities.user.roles,
    gcipTenantId: state.entities.user.gcipTenantId,
    loading: state.entities.customers.loading,
    tenantList: state.entities.customers.tenantList
})

const mapDispatchToProps = (dispatch) => ({
    getUsersList: (gcipTenantId, customerId, roleType) => dispatch(getUsersList(gcipTenantId, customerId, roleType)),
    removeAdmin: (userId) => dispatch(removeAdmin(userId)),
    unSetStatusCode: () => dispatch(unSetStatusCode()),
    resetAdminPassword: (email, roleType) => dispatch(resetAdminPassword(email, roleType))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminManagement))